import type { Content } from "@amzn/ads-discovery-theme-service-typescript-client";
import type { AsyncState, UseAsyncActions } from "@react-hookz/web";
import { useAsync } from "@react-hookz/web";

import { getDiscoveryApiClient } from "../../api/discoveryApi/discoveryApi";
import { ContentPreviewType } from "../../types/content";
import { useAsyncErrorStatusNotification } from "../notifications/useAsyncErrorStatusNotification";
export function useSingleMarketingNarrativeAction(): [
    AsyncState<Content>,
    UseAsyncActions<Content, [string]>,
] {
    const [singleMarketingContentState, singleMarketingContentAction] =
        useAsync(async (marketingContentId: string) => {
            // This action is used to render the summary card for the insight, and as such is marked as preview
            const response = await (
                await getDiscoveryApiClient()
            ).getContentDetails(
                marketingContentId,
                ContentPreviewType.ORIGINAL,
                true,
            );
            return response.content ?? {};
        }, {});
    useAsyncErrorStatusNotification(singleMarketingContentState, [
        "UnauthorizedException",
    ]);
    return [singleMarketingContentState, singleMarketingContentAction];
}
